<table width="100%">
    <tr>
        <td>
            Panier
        </td>
        <td class="text-right">
            <button class="button-mode" *ngIf="chosenOrderType>0" (click)="changeMode()">
                <span> {{orderTypLabel}} </span>
            </button>
        </td>
    </tr>
</table>
<div class="separator"></div>
<div class="list">
    <table width="100%">
        <tbody *ngFor="let el of order?.elements;let i=index">
            <tr class="space"></tr>
            <tr valign="top">
                <td width="40px">
                    <img [src]="el.avatar|absolutePath:'products'" class="w3-bar-item w3-circle w3-hide-small"
                        style="width:85px">
                </td>
                <td class="pl-25">
                    <span>
                        <button class="moins" (click)="decrQty(i,0)">
                            <img src="assets/images/icons/moins.png" class="w3-bar-item w3-circle w3-hide-small">
                        </button>
                        <button class="moins">{{el.qty}}</button>
                        <button class="plus" (click)="incrQty(i,0)">
                            <img src="assets/images/icons/plus.png" class="w3-bar-item w3-circle w3-hide-small">
                        </button>
                    </span>
                    <span>{{el.name}}</span><br>
                    <span>({{el.size.size}} {{el.priceWithSupp | number : '1.2-2'}} €)</span><br>
                    <span class="supp" *ngIf="el.removedCompositions?.length>0">
                        <span class="ingTitle">sans :</span>
                        <ul>
                            <li *ngFor="let comp of el.removedCompositions">
                                <span>{{comp.text}} </span>
                            </li>
                        </ul>

                    </span>
                    <span class="supp" *ngIf="el.optionIngredients?.length>0">
                        <span class="ingTitle">options :</span>
                        <ul>
                            <li *ngFor="let opt of el.optionIngredients">
                                <span>{{opt.text}} </span>
                            </li>
                        </ul>
                    </span>
                    <span class="supp" *ngIf="el.supplements?.length>0">
                        <span class="ingTitle">supp :</span>
                        <ul>
                            <li *ngFor="let supp of el.supplements">
                                <span>{{supp.text}} ( {{supp.price}} €)</span>
                            </li>
                        </ul>
                    </span>
                    <span class="supp" *ngIf="el.comment">
                        <span class="ingTitle">Commentaire :</span>
                        <span>{{el.comment}}</span>
                    </span>
                </td>
                <td width="40px" class="text-right">
                    <span class="trash">
                        <i class="flaticon-garbage" (click)="removeElement(i,0)"></i>
                    </span>
                </td>
            </tr>
            <tr class="tr-price">
                <td width="40px">
                </td>
                <td class="pl-25">
                </td>
                <td width="40px" class="text-right">
                    <span class="price">{{el.total | number : '1.2-2'}} €</span>
                </td>
            </tr>
        </tbody>
        <tbody *ngFor="let menu of order?.menus;let i=index">
            <tr class="space"></tr>
            <tr valign="top">
                <td width="40px">
                    <img [src]="menu.avatar|absolutePath:'menus'" class="w3-bar-item w3-circle w3-hide-small"
                        style="width:85px">
                </td>
                <td class="element-title pl-25">
                    {{menu.title}}
                    <span *ngIf="menu.offer==null">{{menu.priceWithSupp | number : '1.2-2'}} €</span>
                    <ul>
                        <li *ngFor="let el of menu?.elements;let i=index">
                            {{el.name}} <br>
                            <span *ngIf="el.size.level>0">({{el.size.label}})</span> <br *ngIf="el.size.level>0">
                            <span class="supp" *ngIf="el.removedCompositions?.length>0">
                                <span class="ingTitle">sans :</span>
                                <ul>
                                    <li *ngFor="let comp of el.removedCompositions">
                                        <span>{{comp.text}} </span>
                                    </li>
                                </ul>
                            </span>
                            <span class="supp" *ngIf="el.optionIngredients?.length>0">
                                <span class="ingTitle">options :</span>
                                <ul>
                                    <li *ngFor="let opt of el.optionIngredients">
                                        <span>{{opt.text}} </span>
                                    </li>
                                </ul>
                            </span>
                            <span class="supp" *ngIf="el.supplements?.length>0">
                                <span class="ingTitle">supp :</span>
                                <ul>
                                    <li *ngFor="let supp of el.supplements">
                                        <span>{{supp.text}} ( {{supp.price}} €)</span>
                                    </li>
                                </ul>
                            </span>
                        </li>
                        <li *ngFor="let el of menu?.additionalOptions">
                            {{el.name}} ({{el.size}} {{el.price}} €)
                        </li>
                    </ul>
                    <p>{{menu.comment}}</p>
                </td>
                <td width="40px" class="text-right">
                    <span class="trash">
                        <i class="flaticon-garbage" (click)="removeElement(i,1)"></i>
                    </span>
                </td>
            </tr>
            <tr class="tr-price">
                <td width="40px">
                </td>
                <td class="pl-25">
                </td>
                <td width="40px" class="text-right">
                    <span class="price"> {{menu.total | number : '1.2-2'}} €</span>
                </td>
            </tr>
        </tbody>

        <tbody>
            <tr class="space"></tr>
            <tr *ngIf="order.discount>0 || order.coupon>0 || order.fees>0">
                <td colspan="2">Sous-total </td>
                <td class="text-right">{{order.amount | number : '1.2-2'}}€</td>
                <td></td>
            </tr>
            <tr *ngIf="order.discount>0">
                <td colspan="2">Remise {{order.discount}}% </td>
                <td class="text-right">{{order.discountValue | number : '1.2-2'}} €</td>
            </tr>
            <tr *ngIf="order.coupon>0">
                <td colspan="2">
                    Coupon {{order.coupon}} <ng-container *ngIf="order.couponType==1">€</ng-container>
                    <ng-container *ngIf="order.couponType==2">%</ng-container>
                </td>
                <td class="text-right">{{order.couponValue | number : '1.2-2'}} €</td>
            </tr>
            <tr *ngIf="order.fees>0">
                <td colspan="2">{{order.feesLabel}} :</td>
                <td class="text-right">{{order.fees | number : '1.2-2'}} €</td>
            </tr>
            <tr class="orderTotal">
                <td colspan="2">TOTAL TTC</td>
                <td class="text-right" width="100px">
                    {{order?.total | number : '1.2-2'}} €
                </td>
            </tr>
            <tr class="space"></tr>
        </tbody>
    </table>
    <div class="actions">
        <div class="text-center back">
            <button (click)="back()">
                <img src="assets/images/icons/left.png" width="30px" alt="left">
            </button>
        </div>
        <div class="text-center validate">
            <button (click)="validate()">
                <p>Valider
                    <span class="pull-right">{{order?.total | number : '1.2-2'}} €</span></p>

            </button>
        </div>
    </div>
</div>
<ng-template #template>
    <div class="modal-body text-center">
        <p>
            <i class="fa fa-exclamation-triangle fa-2 text-navy" aria-hidden="true"></i>
        </p>
        <p>Vous êtes sur le point de modifier le mode de votre commande.</p>
        <p>Si vous continuez, votre panier sera automatiquement vidé. Continuer ?</p>
        <button type="button" class="btn btn-default" (click)="confirm()">OUI</button>
        <button type="button" class="btn btn-template" (click)="decline()">NON</button>
    </div>
</ng-template>
<ng-template #template2>
    <div class="modal-body text-center">
        <p>
            <i class="fa fa-exclamation-triangle fa-2 text-navy" aria-hidden="true"></i>
        </p>
        <p>Montant minimum de livraison: {{amountMiniDelivery}} €, Voulez vous continue comme meme?</p>
        <button type="button" class="btn btn-default" style="margin-right: 12px;" (click)="confirm2()">OUI</button>
        <button type="button" class="btn btn-primary" (click)="decline()">NON</button>
    </div>
</ng-template>